import { ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const MerchCard = ({ item }) => {
  const navigate = useNavigate();

  return (
    <div 
      className="glass-card overflow-hidden card-hover group cursor-pointer"
      onClick={() => navigate(`/merch/${item.id}`)}
      data-testid={`merch-card-${item.id}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <img 
          src={item.image_url} 
          alt={item.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        
        {/* Hover content */}
        <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
          <button 
            className="w-full btn-primary flex items-center justify-center gap-2"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/merch/${item.id}`);
            }}
            data-testid={`view-merch-${item.id}`}
          >
            <ShoppingCart className="w-4 h-4" />
            View Item
          </button>
        </div>

        {!item.in_stock && (
          <div className="absolute top-4 right-4 px-3 py-1 bg-red-500/80 rounded-full text-xs font-medium">
            Sold Out
          </div>
        )}
      </div>

      <div className="p-4">
        <h3 className="font-semibold text-white truncate mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          {item.name}
        </h3>
        <p className="text-sm text-gray-400 truncate mb-2">{item.category}</p>
        <span className="text-purple-400 font-medium text-lg subheading">${item.price.toFixed(2)}</span>
      </div>
    </div>
  );
};
